
import { useLocation, useNavigate } from "react-router-dom";
import API from "../services/api";

function MobileTabbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = async () => {
    try { await API.post("/auth/logout"); } catch (e) { console.error(e); }
    finally { localStorage.removeItem("admin"); window.location.href = "/"; }
  };

  const tabs = [
    ["▦", "Inicio", "/dashboard"],
    ["♙", "Clientes", "/clients"],
    ["♟", "Operadores", "/operators"],
    ["◉", "Alertas", "/alerts"],
    ["$", "Finanzas", "/finances"],
  ];

  return (
    <nav className="cc-mobile-nav">
      {tabs.map(([icon, label, path]) => (
        <button
          key={path}
          className={location.pathname === path || (path === "/clients" && location.pathname.startsWith("/client/")) ? "active" : ""}
          onClick={() => navigate(path)}
        >
          <span className="mobile-icon">{icon}</span>{label}
        </button>
      ))}
      <button onClick={logout}><span className="mobile-icon">↪</span>Salir</button>
    </nav>
  );
}

export default MobileTabbar;
